import { IconModel } from '../models/icon/icon.model';
import { ButtonModel } from '../models/button/button.model';
import { MenuModel } from '../models/menu/menu.model';
import { ToolbarModel } from '../models/toolbar/toolbar.model';
import { ToolbarStylingModel } from '../models/toolbar/toolbar-styling.model';

export const /** @type {?} */ ToolbarTemplates = {
  defaultTemplate: {
    property: new ToolbarModel({
      display: true,
      disable: false,
      type: 'info',
      info: {
        show: true,
        icon: new IconModel({name: 'info'}),
        order: 0
      },
      content: {
        show: true,
        title: 'Toolbar title',
        template: null,
        order: 1
      },
      actions: {
        show: true,
        menu: new MenuModel({
          triggerIcon: new IconModel({ name: 'more_vert' }),
          itemsSource: 'fromModel',
          menuItems: [
            {
              buttonProperty: new ButtonModel({
                label: 'Menu item',
                iconProperty: null,
                iconPosition: 'left'
              }),
              notification: null,
              divider: false
            }
          ]
        }),
        order: 2
      },
      help: {
        show: true,
        icon: new IconModel({name: 'help'}),
        order: 3
      },
      close: {
        show: true,
        icon: new IconModel({name: 'close'}),
        order: 4
      },
      maximization: {
        show: true,
        maximized: false,
        minimizeIcon: new IconModel({'name': 'remove'}),
        maximizeIcon: new IconModel({'name': 'web_asset'}),
        order: 5
      },
      expandable: {
        show: true,
        expanded: true,
        icon: new IconModel({'name': 'arrow_drop_down'}),
        order: 6
      }
    })
  }
}
